"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _STRtree = _interopRequireDefault(require("../index/strtree/STRtree"));

var _NodedSegmentString = _interopRequireDefault(require("./NodedSegmentString"));

var _MonotoneChainOverlapAction = _interopRequireDefault(require("../index/chain/MonotoneChainOverlapAction"));

var _MonotoneChainBuilder = _interopRequireDefault(require("../index/chain/MonotoneChainBuilder"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

var _SinglePassNoder2 = _interopRequireDefault(require("./SinglePassNoder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MCIndexNoder =
/*#__PURE__*/
function (_SinglePassNoder) {
  _inherits(MCIndexNoder, _SinglePassNoder);

  function MCIndexNoder() {
    var _this;

    _classCallCheck(this, MCIndexNoder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MCIndexNoder).call(this));
    MCIndexNoder.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(MCIndexNoder, [{
    key: "getMonotoneChains",
    value: function getMonotoneChains() {
      return this._monoChains;
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      return _NodedSegmentString.default.getNodedSubstrings(this._nodedSegStrings);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._index;
    }
  }, {
    key: "add",
    value: function add(segStr) {
      var segChains = _MonotoneChainBuilder.default.getChains(segStr.getCoordinates(), segStr);

      for (var i = segChains.iterator(); i.hasNext();) {
        var mc = i.next();
        mc.setId(this._idCounter++);

        this._index.insert(mc.getEnvelope(), mc);

        this._monoChains.add(mc);
      }
    }
  }, {
    key: "computeNodes",
    value: function computeNodes(inputSegStrings) {
      this._nodedSegStrings = inputSegStrings;

      for (var i = inputSegStrings.iterator(); i.hasNext();) {
        this.add(i.next());
      }

      this.intersectChains();
    }
  }, {
    key: "intersectChains",
    value: function intersectChains() {
      var overlapAction = new SegmentOverlapAction(this._segInt);

      for (var i = this._monoChains.iterator(); i.hasNext();) {
        var queryChain = i.next();

        var overlapChains = this._index.query(queryChain.getEnvelope());

        for (var j = overlapChains.iterator(); j.hasNext();) {
          var testChain = j.next();

          if (testChain.getId() > queryChain.getId()) {
            queryChain.computeOverlaps(testChain, overlapAction);
            this._nOverlaps++;
          }

          if (this._segInt.isDone()) return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MCIndexNoder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return MCIndexNoder;
}(_SinglePassNoder2.default);

exports.default = MCIndexNoder;

var SegmentOverlapAction =
/*#__PURE__*/
function (_MonotoneChainOverlap) {
  _inherits(SegmentOverlapAction, _MonotoneChainOverlap);

  function SegmentOverlapAction() {
    var _this2;

    _classCallCheck(this, SegmentOverlapAction);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SegmentOverlapAction).call(this));
    SegmentOverlapAction.constructor_.apply(_assertThisInitialized(_this2), arguments);
    return _this2;
  }

  _createClass(SegmentOverlapAction, [{
    key: "overlap",
    value: function overlap() {
      if (arguments.length === 4) {
        var mc1 = arguments[0],
            start1 = arguments[1],
            mc2 = arguments[2],
            start2 = arguments[3];
        var ss1 = mc1.getContext();
        var ss2 = mc2.getContext();

        this._si.processIntersections(ss1, start1, ss2, start2);
      } else return _get(_getPrototypeOf(SegmentOverlapAction.prototype), "overlap", this).apply(this, arguments);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentOverlapAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SegmentOverlapAction;
}(_MonotoneChainOverlapAction.default);

SegmentOverlapAction.constructor_ = function () {
  this._si = null;
  var si = arguments[0];
  this._si = si;
};

MCIndexNoder.SegmentOverlapAction = SegmentOverlapAction;

MCIndexNoder.constructor_ = function () {
  this._monoChains = new _ArrayList.default();
  this._index = new _STRtree.default();
  this._idCounter = 0;
  this._nodedSegStrings = null;
  this._nOverlaps = 0;

  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var si = arguments[0];

    _SinglePassNoder2.default.constructor_.call(this, si);
  }
};